<template>
  <div class="count-collecting-card">

    <!-- Title + Pagination -->
    <div class="d-flex justify-content-between align-items-center mb-2">

      <div class="text-uppercase text-muted small font-weight-bold">
        Données collectées (Tendance du jour)
      </div>

      <div class="d-flex align-items-center">

        <!-- Left -->
        <img
          alt="left"
          width="16"
          src="@/assets/icons/left-2.svg"
          class="mr-2"
          style="cursor: pointer;"
          @click="previousPage"
          :style="{
            opacity: pageChart === 1 ? 0.5 : 1,
            pointerEvents: pageChart === 1 ? 'none' : 'auto'
          }"
        />

        <span class="small mr-2">page {{ pageChart }}</span>

        <!-- Right -->
        <img
          alt="right"
          width="16"
          src="@/assets/icons/right-2.svg"
          style="cursor: pointer;"
          @click="nextPage"
          :style="{
            opacity: pageChart >= maxPage ? 0.5 : 1,
            pointerEvents: pageChart >= maxPage ? 'none' : 'auto'
          }"
        />

      </div>

    </div>

    <!-- Chart -->
    <apexchart
      ref="apexchart"
      :key="apexChartsBarArea"
      v-if="chartOptions && chartOptions.series && chartOptions.series.length"
      type="bar"
      height="200"
      :options="chartOptions"
      :series="chartOptions.series"
    />

  </div>
</template>

<script>
import ReportingApi from "@/services/reporting-api";

export default {
  props: {
    title: String,
    name: String,
    campaignId: Number,
    countCollectingDataByDay: Object,
    range: Object
  },

  data() {
    return {
      chartOptions: {},
      apexChartsBarArea: 0,
      pageChart: 1,
      pageSize: 10,
      fullData: null
    };
  },

  computed: {
    maxPage() {
      if (!this.fullData?.date) return 1;
      return Math.ceil(this.fullData.date.length / this.pageSize);
    },

    totalCount() {
      return (
        this.fullData?.countByDay?.reduce((a, b) => a + b, 0) || 0
      );
    }
  },

  watch: {
    campaignId() {
      this.pageChart = 1;
      this.getData();
    },

    range: {
      handler(newVal) {
        if (newVal?.startDate && newVal?.endDate) {
          this.pageChart = 1;
          this.getData();
        }
      },
      deep: true
    }
  },

  mounted() {
    this.getData();
  },

  methods: {

    getData() {
      const params = {
        campaignId: this.campaignId,
        start: this.range.startDate,
        end: this.range.endDate
      };

      ReportingApi.getCollectingDataPerDay(params).then(result => {
        if (result) {
          this.fullData = result;
          this.renderChart();
        }
      });
    },

    nextPage() {
      if (this.pageChart < this.maxPage) {
        this.pageChart++;
        this.renderChart();
      }
    },

    previousPage() {
      if (this.pageChart > 1) {
        this.pageChart--;
        this.renderChart();
      }
    },

    renderChart() {
      if (!this.fullData) return;

      const startIndex = (this.pageChart - 1) * this.pageSize;
      const endIndex = startIndex + this.pageSize;

      const paginatedDates = this.fullData.date.slice(startIndex, endIndex);
      const paginatedCounts = this.fullData.countByDay.slice(startIndex, endIndex);

      this.chartOptions = {
        series: [
          {
            name: "Scans",
            data: paginatedCounts
          }
        ],

        chart: {
          type: "bar",
          height: 200
        },

        xaxis: {
          categories: paginatedDates,
          labels: {
            show: true,
            rotate: -45,
            style: {
              fontSize: '10px'
            }
          }
        },

        yaxis: {
          labels: {
            show: false
          }
        },

        plotOptions: {
          bar: {
            columnWidth: '85%',
            borderRadiusApplication: 'end',
            endingShape: 'rounded',
            borderRadius: 2
          }
        },

        stroke: {
          show: true,
          width: 1,
          colors: ['#a1a5fa']
        },

        colors: ["#5b5ce2"],

        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "vertical",
            gradientToColors: ["#8f94fb"],
            opacityFrom: 0.9,
            opacityTo: 0.8
          }
        },

        tooltip: {
          enabled: true,
          x: {
            formatter: (val, { dataPointIndex }) => {
              return paginatedDates[dataPointIndex];
            }
          },
          y: {
            formatter: (val) => Math.round(val)
          }
        }
      };

      this.apexChartsBarArea++;
    }
  }
};
</script>

<style scoped>
.count-collecting-card {
  background: #f5f7fb;
  border-radius: 16px;
  padding: 20px;
}

.big-number {
  font-size: 28px;
  color: #111827;
}
</style>